const sendPlanChange = (): void => {
  window.postMessage({ message: 'app:plan:change' }, '*');
};

export default sendPlanChange;
